import React from 'react'
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import TimesDropdown from './times-dropdown.component'

const START = 'START'
const END = 'END'
const LIMIT = 3
const ADD = 'add'

const StepThree = (props) => {
  const { t } = useTranslation()
  const { hours, setHours, formAction, disableHours } = props

  return (
    <div className='add-capacity-by-resource-step-three'>
      {hours.length === 0 && <h2>{t('jobs.timeline.resources.scheduleRange')}</h2>}
      {hours.map((time, i) => {
        return (
          <div key={`time-${i}`} className='timetable'>
            <h3>{`${t('resources.capacity.edit-form.start')} ${i + 1}`}</h3>
            <TimesDropdown
              timeTable={hours}
              setTimeTable={setHours}
              timeNum={i}
              disableHours={disableHours}
              type={START}
            />
            <h3>{`${t('resources.capacity.edit-form.end')} ${i + 1}`}</h3>
            <TimesDropdown timeTable={hours} setTimeTable={setHours} timeNum={i} type={END} />
            <CloseCircleOutlined onClick={(_) => setHours([...hours.slice(0, i), ...hours.slice(i + 1)])} />
          </div>
        )
      })}

      <section className='add-btn'>
        <Button
          className='add-btn'
          onClick={(_) => {
            if (hours.length < LIMIT) setHours([...hours, { start: '', end: '' }])
          }}
          type='primary'
        >
          <PlusOutlined />
        </Button>
        <span>{t('jobs.timeline.resources.btnTxt')}</span>
      </section>

      {hours.length < 2 && formAction === ADD && (
        <div className='message'>
          <b>{t('jobs.timeline.resources.help')}:</b> {t('jobs.timeline.resources.message')}
        </div>
      )}
    </div>
  )
}

export default StepThree
